<template>
  <div id="checks" uk-height-viewport>
    <Header />

    <div uk-grid class="uk-margin uk-margin-remove-right">
      <div class="uk-width-auto">
        <legend class="uk-legend uk-margin-left uk-text-left uk-text-bold">Checks</legend>
      </div>
      <div class="uk-width-auto">
        <div class="uk-margin" v-show="!isLoading">
          <div uk-form-custom="target: > * > span:first-child">
            <select class="uk-select uk-border-rounded" v-model="filterStatus" @change="updateFilteredChecks()">
              <option value="all">Tous</option>
              <option
                v-for="(status, index) in dataStatuses"
                :value="status.type"
                :key="index"
              >{{status.title}}</option>
            </select>
            <button
              class="uk-button uk-button-default uk-border-rounded"
              type="button"
              tabindex="-1"
            >
              <span></span>
              <span uk-icon="icon: chevron-down"></span>
            </button>
          </div>
        </div>
      </div>
      <div class="uk-width-expand"></div>
      <div class="uk-width-expand">
        <div class="uk-align-right uk-margin-right">
          <router-link to="/checks/edit-check">
            <button
              class="uk-button uk-button-default uk-button-right uk-border-rounded uk-text-bold uk-margin-bottom"
            >
              <span class="uk-icon uk-margin-small-right" uk-icon="icon: plus"></span>Créer un check
            </button>
          </router-link>
        </div>
      </div>
    </div>

    <div class="uk-flex uk-flex-center">
      <div
        class="uk-margin uk-grid-small uk-child-width-auto uk-flex uk-flex-center"
        uk-spinner
        v-show="isLoading"
      ></div>
      <table
        class="uk-table uk-table-small uk-table-divider uk-table-hover uk-table-justify"
        id="checksTable"
        v-show="!isLoading"
      >
        <thead>
          <tr>
            <th class="uk-text-center">
              <p class="uk-text-bold">Titre</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Lieu</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Client</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Checker</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Statut</p>
            </th>
            <th class="uk-text-center">
              <p class="uk-text-bold">Action</p>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(check, index) in filteredChecks" :key="index">
            <td class="uk-text-middle">{{check.title}}</td>
            <td class="uk-text-middle">{{check.address}}, {{check.zipCode}} {{check.city}}</td>
            <td class="uk-text-middle">{{check.customerIdentity}}</td>
            <td class="uk-text-middle">{{check.participatingUsername}}</td>
            <td class="uk-text-middle">{{getReadableStatus(check.status)}}</td>
            <td class="uk-text-middle">
              <router-link :to="{ path: `/checks/edit-check/${check.uid}` }">
                <span
                  class="uk-form-info uk-margin-small-left uk-margin-small-right"
                  style="cursor:pointer;"
                  uk-tooltip="title: Éditer; delay: 500"
                  uk-icon="file-edit"
                ></span>
              </router-link>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import CheckStatus from "../enums/check-status";
import Check from "../models/check";
import FirestoreCollection from "../enums/firestore-collection";
import firebase from "firebase";
import Header from "../components/Header";

export default {
  name: "quotation",
  components: {
    Header
  },
  data() {
    return {
      checks: [],
      filteredChecks: [],
      isLoading: true,
      filterStatus: "all",
      dataStatuses: [
        { type: CheckStatus.OPEN, title: "Non affecté" },
        {
          type: CheckStatus.PENDING,
          title: "Affecté (en attente de réalisation)"
        },
        { type: CheckStatus.WAITING_REVIEW, title: "Attente correction" },
        { type: CheckStatus.INVOICED, title: "Terminé (facturé)" },
        { type: CheckStatus.DONE, title: "Terminé" },
        { type: CheckStatus.UNDEFINED, title: "Non défini" }
      ]
    };
  },

  mounted() {
    const self = this;
    firebase
      .firestore()
      .collection(FirestoreCollection.CHECKS)
      .orderBy("createdAt", "desc")
      .get()
      .then(querySnapshot => {
        self.isLoading = false;
        querySnapshot.forEach(doc => {
          this.checks.push(new Check(doc));
          this.filteredChecks = this.checks
        });
      })
      .catch(function(error) {
        console.log("Error getting documents: ", error);
      });
  },

  methods: {
    getReadableStatus(status) {
      switch (status) {
        case CheckStatus.OPEN:
          return "Non affecté";
        case CheckStatus.PENDING:
          return "Affecté (en attente de réalisation)";
        case CheckStatus.WAITING_REVIEW:
          return "En attente de correction";
        case CheckStatus.DONE:
          return "Terminé";
        case CheckStatus.INVOICED:
          return "Terminé (facturé)";
        case CheckStatus.UNDEFINED:
          return "Non défini";
      }
    },

    updateFilteredChecks: function() {
      if (this.filterStatus === 'all') {
        this.filteredChecks = this.checks
        return
      }
      this.filteredChecks = this.checks.filter(e => this.filterStatus == e.status)
    },

    toNumericReadableFormat: function(date) {
      var day = date.getDate();
      var monthIndex = date.getMonth() + 1;
      var year = date.getFullYear();
      return "" + day + "/" + monthIndex + "/" + year;
    },

  }
};
</script>

<style scoped>
table tbody tr:hover {
  background-color: rgba(48, 158, 181, 0.05);
}
</style>